var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-interactions-content" },
    [
      _vm._l(_vm.sortedInteractions, function(interaction, index) {
        return _c(
          "div",
          { key: index, staticClass: "ai-interactions-content__item" },
          [
            _c(
              "div",
              {
                staticClass:
                  "ai-interactions-content__item-header typographies-paragraph-medium-semibold"
              },
              [
                _c("CompassAvatar", {
                  attrs: {
                    initials: _vm.getInitials(interaction.user),
                    size: "extra-small",
                    colorType: _vm.getAvatarColor(interaction.user)
                  }
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(interaction.user.firstname) +
                    " " +
                    _vm._s(interaction.user.lastname) +
                    "\n        "
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("p", { staticClass: "ai-interactions-content__item-summary" }, [
              _vm._v(_vm._s(interaction.summary))
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "ai-interactions-content__item-date typographies-paragraph-medium-regular"
              },
              [
                _c("CompassIcon", {
                  attrs: { icon: "calendar", size: "small" }
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.formatDate(interaction.date)) +
                    "\n        "
                )
              ],
              1
            )
          ]
        )
      }),
      _vm._v(" "),
      _vm.hasNoData
        ? _c("NoInvoicingData", {
            attrs: {
              content: _vm.$t.__("overview.tabs.TabSummary.noInteractionData")
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }